// extracted by mini-css-extract-plugin
export default {"Title":"CreateFolderModal_Title__cUFzj","Description":"CreateFolderModal_Description__u9NT2","Alert":"CreateFolderModal_Alert__a-GEe","Buttons":"CreateFolderModal_Buttons__RvGxm"};